import { useEffect } from "react";
import { Link } from "react-router-dom";
import { ArrowUpRight } from "lucide-react";
import { FadeUp } from "@/components/Reveal";

const COLLECTIONS = [
  {
    to: "/collections/jojo-drop-001",
    no: "COLLECTION 01",
    title: "JOJO DROP 001",
    line: "LUXURY ANIME STREETWEAR, CURATED IN INDIA",
    img: "/products/v3/sbr-tee-detail.webp",
    testid: "collection-card-jojo-drop-001",
  },
  {
    to: "/collections/evangelion-drop",
    no: "COLLECTION 02",
    title: "EVANGELION DROP 002",
    line: "INDUSTRIAL MONOCHROME WITH RESTRAINED VIOLET",
    img: "/products/v3/hoodie-model-back.webp",
    testid: "collection-card-evangelion-drop",
  },
];

export default function Shop() {
  useEffect(() => {
    document.title = "SHOP — REQUIEM FEVER";
  }, []);

  return (
    <div className="min-h-screen bg-ink" data-testid="shop-page">
      <div className="mx-auto max-w-7xl px-5 py-14 sm:px-8 sm:py-20">
        <div className="border-b border-white/10 pb-8">
          <FadeUp>
            <p className="font-mono text-[10px] uppercase tracking-[0.35em] text-gold">TWO WORLDS. ONE LABEL.</p>
          </FadeUp>
          <FadeUp delay={0.08}>
            <h1 className="mt-3 font-display text-5xl leading-[0.9] tracking-[0.01em] text-bone sm:text-7xl">
              THE COLLECTIONS
            </h1>
          </FadeUp>
          <FadeUp delay={0.14}>
            <p className="mt-5 max-w-lg text-sm leading-relaxed text-bone/60">
              Every piece lives in exactly one collection. Choose your world.
            </p>
          </FadeUp>
        </div>

        <div className="mt-12 grid gap-6 sm:mt-16 md:grid-cols-2">
          {COLLECTIONS.map((c, i) => (
            <FadeUp key={c.to} delay={i * 0.1}>
              <Link
                to={c.to}
                data-testid={c.testid}
                className="group relative block overflow-hidden border border-line bg-surface"
              >
                <div className="relative aspect-[4/5] overflow-hidden sm:aspect-[3/4]">
                  <img
                    src={c.img}
                    alt={c.title}
                    loading="lazy"
                    decoding="async"
                    className="absolute inset-0 h-full w-full object-cover object-center transition-transform duration-700 ease-out group-hover:scale-[1.03]"
                  />
                  <div className="absolute inset-0 bg-gradient-to-t from-ink via-ink/25 to-transparent" />
                  <div className="absolute inset-x-0 bottom-0 p-6 sm:p-8">
                    <p className="font-mono text-[10px] uppercase tracking-[0.35em] text-gold">{c.no}</p>
                    <h2 className="mt-2 font-display text-4xl leading-none tracking-[0.02em] text-bone sm:text-5xl">
                      {c.title}
                    </h2>
                    <p className="mt-3 font-mono text-[9px] uppercase leading-relaxed tracking-[0.25em] text-bone/60">
                      {c.line}
                    </p>
                    <p className="mt-4 inline-flex items-center gap-2 border-b border-gold/60 pb-1 font-mono text-[10px] uppercase tracking-[0.3em] text-gold transition-colors group-hover:border-bone group-hover:text-bone">
                      EXPLORE COLLECTION
                      <ArrowUpRight className="h-4 w-4" strokeWidth={1.5} />
                    </p>
                  </div>
                </div>
              </Link>
            </FadeUp>
          ))}
        </div>
      </div>
    </div>
  );
}

